import { render, staticRenderFns } from "./Lgx179845367947329536.vue?vue&type=template&id=868c6e94&"
import script from "./Lgx179845367947329536.vue?vue&type=script&lang=js&"
export * from "./Lgx179845367947329536.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports